<template>
  <div class="team">
    <div class="tway-title-hero"></div>
    <div class="quote">
      <v-container class="text-center">
        <div class="main-headline tway-morado--text mx-auto">
          <span>Transformar requiere un liderazgo con mentalidad flexible y ágil.</span>
          <br>
          <span>Es un proceso Transversal, Multidisciplinario y Colaborativo</span>
        </div>
        <div class="tway-headline-extra-info grey--text text--darken-3 mx-auto mt-5" style="max-width: 870px;">
          En el Ranking de Competitividad Digital 2020 IMD realizado en 64 países, Chile se ubica en el lugar 44, Colombia
          en 53 y México 54. </div>
      </v-container>
    </div>
    <div class="team-tway">
      <v-container>
        <div class="tway-headline-2 text-center tway-morado--text mb-5">
          El Equipo Tway
        </div>
        <v-row :class="mobile ? 'px-3' : 'px-10'">
          <v-col v-for="(member, memberIndex) in team" :key="member.name" class="pa-1"
            :cols="memberSelected == memberIndex ? '12' : '4'" :xs="memberSelected == memberIndex ? '12' : '4'"
            :sm="memberSelected == memberIndex ? '12' : '4'" md="3" lg="3"
            :style="mobile ? 'order: ' + memberIndex.toString() : ''">
            <div>
              <v-hover v-slot:default="{ hover }">
                <v-img @click="() => { memberSelected = memberIndex }" class="rounded-image hover_img"
                  :src="require(`@/assets/images/team/${member.image}`)" aspect-ratio="1">
                  <v-fade-transition>
                    <div v-if="hover || (mobile && memberSelected == memberIndex)" class="d-flex flex-column"
                      style="height: 100%;">
                      <div class="d-flex tway-morado"
                        style="height: 100%;width: 100%;opacity: 0.6;position: absolute;z-index: -1;">
                      </div>
                      <div class="white--text tway-body pa-5 mt-auto" style="width: 100%;opacity: 1;">
                        <div :class="mid ? 'text-name-sm' : 'text-name-md'" class="mt-5">
                          {{ member.name }}
                        </div>
                        <div :class="mid ? 'text-role-sm' : 'text-role-md'">
                          {{ member.role }}
                        </div>
                        <div>
                          <div class="social">
                            <a :href="member.social.linkedIn" style="text-decoration: none;" target="_blank">
                              <v-icon color="white">
                                mdi-linkedin
                              </v-icon>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </v-fade-transition>
                </v-img>
              </v-hover>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <div class="tech-partner">
      <v-container>
        <div class="text-center mobile-plan-card-container" v-if="true">
          <v-card :elevation="0" class="mobile-plan-card">
            <div class="mobile-plan-card-width">
              <div>
                <v-btn v-if="!mobile" class="mx-2 arrow-btn-left withe-text" fab dark color="tway-violeta"
                  @click="prevPage()" :style="page == 0 ? 'background-color: #c499f9 !important' : ''">
                  <v-icon dark>mdi-arrow-left</v-icon>
                </v-btn>
                <v-btn v-if="!mobile" class="mx-2 arrow-btn-right" fab dark color="tway-violeta" @click="nextPage()"
                  :style="page == items.length - 1 ? 'background-color: #c499f9 !important' : ''">
                  <v-icon dark>mdi-arrow-right</v-icon>
                </v-btn>
              </div>
              <v-fade-transition v-for="(item, itemIndex) in items" :key="itemIndex" leave-absolute>
                <div v-if="itemIndex == page">
                  <div class="body-item-text mb-3">
                    <span>{{ item.body }}</span>
                  </div>
                  <div class="tway-headline-3 roboto black--text">
                    <span>{{ item.title }}</span>
                  </div>
                  <div class="tway-body black--text">
                    {{ item.subtitle }}
                  </div>
                </div>
              </v-fade-transition>
            </div>
          </v-card>
          <div class="div-center">
            <div v-for="(item, index) in items" :key="index" @click="page = index" class="circle mx-4 tway-violeta"
              :style="page == index ? 'border: 9px solid rgb(233 212 255) !important; width: 34px !important; height: 34px !important;' : 'background-color: #c499f9 !important'">
            </div>
          </div>
        </div>
      </v-container>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.fade-transition-enter-active {
  transition: 2s cubic-bezier(0.25, 0.8, 0.5, 1) !important;
}

.fade-transition-leave-active {
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1) !important;
  display: none;
}
</style>

<script>
import teamJSON from '@/utils/team.json';

export default {
  data: () => ({
    team: [],
    page: 0,
    memberSelected: null,
    items: [
      {
        body: '“El entorno cambió. Hoy habitamos un sistema conectado, en el que todo tiene un ver con todo. Un ecosistema donde surgen nuevas inteligencias y oportunidades que nos desafían a transformarnos para conservarnos navegando en mercados cada vez más líquidos”',
        title: "María José Acuña",
        subtitle: 'Directora Ejecutiva y Socia Fundadora',
      },
      {
        body: '“He promovido la transformación y comprobado sus resultados. No existe área, empresa o industria que se pueda mantener al margen de esta cuarta revolución.”',
        title: "Luis Eduardo Bravo",
        subtitle: 'Socio y Director de Finanzas',
      },
      {
        body: '“La importancia de construir estrategias centradas en los clientes ha sido el principal aprendizaje de mi trayectoria. La transformación impulsa y crea el conocimiento necesario para generar mejores experiencias y decisiones.”',
        title: "Carola Carrizo",
        subtitle: 'Directora de Marketing y CX y Socia Fundadora',
      },
      {
        body: '“Los mercados son sumamente competitivos. Adaptar la propuesta de valor de cada compañía en forma oportuna es clave para su evolución y conservación.”',
        title: "Freek Van Laar",
        subtitle: 'Socio y Director',
      },
    ]
  }),

  created() {
    this.getTeam();
    setInterval(() => {
      this.nextPage(true);
    }, 10000);
  },

  methods: {
    getTeam() {
      this.team = teamJSON;
    },
    nextPage(val) {
      if (this.page < this.items.length - 1) {
        this.page = this.page + 1;
      } else if (val) {
        this.page = 0;
      }
    },
    prevPage() {
      if (this.page > 0) {
        this.page = this.page - 1;
      }
    }
  },

  computed: {
    mobile() {
      return this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.xs;
    },
    mid() {
      return this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.md;
    }
  }
}
</script>
<style scoped lang="scss">
.main-headline {
  @media only screen and (max-width: $mobile) {
    font-size: 24px;
    line-height: 28px;
  }

  @media only screen and (min-width: $desktop) {
    font-size: 35px;
    line-height: 50px;
  }

  font-family: 'Josefin Sans',
  sans-serif;
  font-style: normal;
  font-weight: normal;
}

.quote {
  padding-top: 50px;
}

.team-tway {
  padding-top: 50px;
}

.circle {
  border-radius: 100%;
  width: 20px;
  height: 20px;
  cursor: pointer;
}

.tech-partner {
  padding-top: 100px;
  padding-bottom: 100px;
}

.div-center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.hover_img {
  position: relative;
}

.hover_img a span {
  position: absolute;
  display: none;
  z-index: 99;
  left: 50%;
  -webkit-transform: translateX(-50%);
  -ms-transform: translateX(-50%);
  transform: translateX(-50%);
}

.hover_img a:hover span {
  display: block;
}

.text-name-sm {
  font-size: 20px;
}

.text-name-md {
  font-size: 25px;
}

.text-role-sm {
  font-size: 14px;
}

.text-role-md {
  font-size: 16px;
}

.rounded-image {
  border-radius: 5px;
}

.rounded-image-center {
  font-weight: bold;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.mobile-plan-card-container {
  margin-top: 1%;
  margin-left: 4%;
  margin-right: 4%;
}

.mobile-plan-card {
  padding-top: 8%;
  padding-bottom: 8%;
  padding-left: 5%;
  padding-right: 5%;
  display: flex;
  justify-content: center;

  .tway-headline-4 {
    font-size: 20px;
    font-weight: lighter !important;
    margin-bottom: 20px !important;
  }

  .tway-headline-3 {
    font-size: 25px;
  }

  .tway-body {
    font-size: 16px;
  }
}

.mobile-plan-card-width {
  max-width: 650px;
}

.mobile-plan-card p {
  margin-top: 4%;
  margin-bottom: 4%;
  text-align: left;
  margin-left: 10%;
}

.mobile-plan-card .v-btn {
  margin-top: 1.5em;
  margin-bottom: 2em;
}

.arrow-btn-left {
  position: absolute;
  left: -5%;
}

.arrow-btn-right {
  position: absolute;
  right: -5%;
}

.body-item-text {
  font-family: Roboto Condensed;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 25px;
  text-align: center;
  color: #333333;
}
</style>